import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useWishlist from 'hooks/useWishlist';

import { stripDuplicates } from 'lib/array';
import { noop } from 'lib/utils';

const Keywords = ({
  gaEventCategory,
  keywords,
  onAddKeyword = noop,
  onRemoveKeyword = noop,
}) => {
  const { addOfferWishlistKeyword, removeOfferWishlistKeyword, offerWishlist } =
    useWishlist(gaEventCategory, {
      gaEventLabel: 'offer_details',
    });

  const isKeywordInWishlist = (keywordDisplay) =>
    offerWishlist?.items.some((item) => item.keywordDisplay === keywordDisplay);

  return (
    <div className="flex flex-wrap gap-2">
      {stripDuplicates(keywords).map((keyword) => {
        const isInWishlist = isKeywordInWishlist(keyword);

        return (
          <Button
            key={keyword}
            className={twJoin(
              'border-none bg-neutral-high-200 dark:bg-rd-secondary-100 [&>span]:text-neutral-low-300 dark:[&>span]:text-neutral-low-300 [&>svg]:text-neutral-high-500 dark:[&>svg]:text-neutral-low-300',
              isInWishlist &&
                'border-none bg-rd-secondary-100 dark:bg-secondary-300 [&>span]:text-neutral-low-300 dark:[&>span]:text-neutral-high-300 [&>svg]:text-secondary-200 dark:[&>svg]:text-secondary-200'
            )}
            iconRight={
              <Icon
                name={twJoin(isInWishlist ? 'megaphone-filled' : 'megaphone')}
              />
            }
            size="size3"
            type="secondary-stroke"
            onClick={() => {
              if (isInWishlist) {
                removeOfferWishlistKeyword({ keywordDisplay: keyword });
                onRemoveKeyword();
                return;
              }

              addOfferWishlistKeyword({ keywordDisplay: keyword });
              onAddKeyword();
            }}
          >
            {keyword}
          </Button>
        );
      })}
    </div>
  );
};

Keywords.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  keywords: PropTypes.arrayOf(PropTypes.string),
  onAddKeyword: PropTypes.func,
  onRemoveKeyword: PropTypes.func,
};

export default Keywords;
